// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".active[data-v-3d3c1e18]{--text-opacity:1;color:#8a9ba5;color:rgba(138,155,165,var(--text-opacity))}", ""]);
// Exports
module.exports = exports;
